import React, { useState, useEffect } from 'react';
import { withStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { useSelector } from 'react-redux';
import { Card, CardContent, List, ListItem, TextField, ListItemIcon, FormControlLabel, Checkbox } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Button from '@mui/material/Button';
import InfoIcon from '@mui/icons-material/Info';
import { useNavigate } from "react-router-dom";
import dayjs from 'dayjs';
import { setCreateBookingResponse } from '../../redux/actions/createBookingActions';
import { useDispatch } from 'react-redux';
import { updateBookingPrice } from '../../redux/actions/bookingActions'; // Import the booking action
import { setLoginResonse } from '../../redux/actions/loginResonseActions';
import CircularProgress from '@mui/material/CircularProgress';
import { pushBookingMakeRequest, pushTermsLoyalityPoint, pushTermsPromoCode, requestTermsCheckout } from '../../gtm';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import NotificationComponent from '../Notifications';
import ProgressBar from '../ProgressBar/ProgressBar';
import { setCreateIntentResponse } from '../../redux/actions/createIntentActions';
import { setPromoCode, setCodeApplied } from '../../redux/actions/setPromoCode';

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#FCFDFD',
  },
  title: {
    color: '#444',
    fontSize: '24px',
    fontFamily: 'Nexa,sans-serif',
    fontWeight: '700',
    backgroundColor: '#fff',
    textAlign: 'center',
    lineHeight: '1.1',
  },
  title2: {
    textAlign: 'center',
    fontSize: '1.8rem',
    fontWeight: '700',
    color: '#333',
    fontFamily: 'Nexa,sans-serif',
    lineHeight: '1.1',
  },
  subtitle: {
    textAlign: 'center',
    fontSize: '20px',
    lineHeight: '1.1',
    fontFamily: 'Nexa,sans-serif',
    fontWeight: '500',
    color: '#265886',
    marginTop: '20px',
    backgroundColor: '#F7FBFF'
  },
  subtitle1: {
    textAlign: 'center',
    fontSize: '1em',
    fontFamily: 'Nexa,sans-serif',
    color: '#444',
    fontWeight: '700',
  },
  button: {
    display: 'flex',
    justifyContent: 'flex-end',
    textTransform: 'none',
  },
  underline: {
    position: 'relative',
    display: 'inline-block',
  },
  underlineBefore: {
    position: 'absolute',
    content: '""',
    left: 20,
    right: 0,
    bottom: -8,
    height: '4px',
    width: '70%',
    backgroundColor: '#138911',
    borderRadius: '5px',
  },
  button1: {
    backgroundColor: 'rgb(17, 137, 17)',
    color: 'rgb(255, 255, 255)',
    borderRadius: '6px',
    marginTop: '14px',
    padding: '0px 50px',
    fontFamily: '"Nexa","Arial",sans-serif!important',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '1.75',
    letterSpacing: '0.02857em',
    minWidth: '183px',
    minHeight: '50px',
    display: 'flex',
    '&.loading': {
      color: theme.palette.primary.main, // Change this to the color you want
    },
  },
  button2: {
    backgroundColor: '#265886',
    color: 'rgb(255, 255, 255)',
    borderRadius: '6px',
    marginTop: '14px',
    padding: '0px 50px',
    fontFamily: '"Nexa","Arial",sans-serif!important',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '1.75',
    letterSpacing: '0.02857em',
    minWidth: '183px',
    minHeight: '50px',
    display: 'flex',
  },
  luggageSection: {
    marginTop: '20px',
  },
  luggageTitle: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
  },
  termsInfo: {
    color: '#265886',
    fontSize: '22px',
    marginBottom: '-5px'
  },
  luggageButton: {
    display: 'flex',
    alignItems: 'center',
  },
  luggageIcon: {
    marginRight: '5px',
  },
  tickIcon: {
    fontWeight: 'bold'
  },
  terms: {
    fontSize: '16px',
    fontFamily: "Nexa,sans-serif",
    color: '#265886'
  },
  price1: {
    fontFamily: '"Nexa","Arial",sans-serif!important',
    fontSize: '30px',
    color: '#265886',
  },
  price2: {
    fontFamily: '"Nexa","Arial",sans-serif!important',
    fontSize: '17px',
    color: '#265886',
    marginLeft: '150px',
    marginTop: '10px'
  },
});
const currencySymbols = {
  GBP: '£', // British Pound
  USD: '$', // US Dollar
  EUR: '€', // Euro
  CAD: 'C$', // Canadian Dollar
  CHF: 'CHF', // Swiss Franc
  NOK: 'kr', // Norwegian Krone
  SEK: 'kr', // Swedish Krona
  AED: 'AED', // United Arab Emirates Dirham
  DKK: 'kr', // Danish Krone
};

const getTransferType = (type) => {
  switch (type) {
    case 'PRIV':
      return "Private";
    case 'SHAR':
      return "Shared";
    case 'EXEC':
      return "Luxury Minibus";
    case 'COAC':
      return "Private Coach";
    case 'LIMO':
      return "Luxury Car";
    case 'SCHD':
      return "Scheduled Shuttle";
    case 'ECON':
      return "Economy";
    case 'PRIO':
      return "Priority Shared";
    case 'SHPL':
      return "Shared Plus";
    case 'PRGF':
      return "Private Golf Transfer";
    case 'GLF':
      return "Golf Transfer";
    case 'PCG':
      return "Private Coach Golf";
    case 'HELI':
      return "Helicopter Transfer"
    case 'SHTL':
      return "Shuttle"
    case 'AP2':
      return "Airport Package 2"
    case 'AP3':
      return "Airport Package 3"
    case 'AP4':
      return "Airport Package 4"
    case 'AP5':
      return "Airport Package 5"
    case 'AP6':
      return "Airport Package 6"
    case 'GP2':
      return "Golf Package Two"
    case 'GP3':
      return "Golf Package Three"
    case 'GP4':
      return "Golf Package Four"
    case 'GP6':
      return "Golf Package Six"
    case 'LSUV':
      return "Luxury SUV"
    case 'DSHU':
      return "Denver Shuttle"
    case 'AOSH':
      return "Aosta Shuttle"
    case 'AP1':
      return "Airport Package 1"
    case 'GP1':
      return "Golf Package One"
    case 'EC1':
      return "Economy Shuttle"
    case 'ECPR':
      return "Economy Private"
    case 'ECLX':
      return "Eco Luxury"
    case 'ECOP':
      return "Eco Private"
    case 'REP':
      return "Meet and Greet Rep"
    default:
      return null;
  }
};

const TermsConditionsForm = ({ classes, theme }) => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const frontBaseUrl = process.env.REACT_APP_BASE_URL;

  // Error for Promo Code
  const [promoCodePopError, setPromoCodePopError] = useState('');
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);

  const openErrorModal = () => {
    setIsErrorModalOpen(true);
  };

  const closeErrorModal = () => {
    setIsErrorModalOpen(false);
  };


  const dispatch = useDispatch();

  // Loading for Payment 
  const [loading, setLoading] = useState(false);
  // Loading for Loyality Points
  const [loadingLoyality, setLoadingLoyality] = useState(false);
  // Loading for Promo Code
  const [loadingPromoCode, setLoadingPromoCode] = useState(false);
  const [loadingText, setLoadingText] = useState(''); // Text to display
  const [dots, setDots] = useState(''); // Animated dots
  const [promoCodeError, setPromoCodeError] = useState('');

  var book = null;

  const createBookingResponse = useSelector(state => state.createBooking);
  const { totalCost, } = useSelector((state) => state.booking);
  const combinations = useSelector((state) => state.mixedProduct.combinations);
  const transferTypeCodeToMatch = createBookingResponse.basket.transfers[0].transferType.code;

  const matchedOption = createBookingResponse.basket.options.find(option => option.transferTypeCode === transferTypeCodeToMatch);

  // console.log("check matched option", matchedOption)
  book = matchedOption ? matchedOption.book : false;
  // console.log("check book option", book)
  // Mixed Product
  // const outboundMatch = combinations.find(combination =>
  //   combination.outbound.transferTypeCode === transferTypeCodeToMatch
  // );

  // const outboundBook = outboundMatch ? outboundMatch.outbound.book : null;

  // const inboundMatch = combinations.find(combination =>
  //   combination.inbound.transferTypeCode === transferTypeCodeToMatch
  // );

  // const inboundBook = inboundMatch ? inboundMatch.inbound.book : null;

  // console.log(combinations)
  // console.log("check create booking response",createBookingResponse)
  if (createBookingResponse.basket.transfers.length > 1 && (createBookingResponse.basket.transfers[0].transferType.code !== createBookingResponse.basket.transfers[1].transferType.code)) {

    const match = combinations.find(combination =>
      combination.outbound.transferTypeCode === transferTypeCodeToMatch ||
      combination.inbound.transferTypeCode === transferTypeCodeToMatch
    );
    // console.log("match chec", match)
    // console.log("checking something")

    book = match ? (match.outbound.transferTypeCode === transferTypeCodeToMatch ? match.outbound.book : match.inbound.book) : false;


  }


  var { costPerPerson, transferType, short_description } = useSelector((state) => state.booking);

  const quoteResponse = useSelector((state) => state.quoteResponse);
  const travelDetails = useSelector(state => state.travelDetails);
  const createBooking = useSelector(state => state.createBooking);

  const mobile = createBooking.basket.transfers[0].mobile;
  const smsCheck = mobile.startsWith('+1');

  // Sample usage
  const [paymentProvider, setPaymentProvider] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);

    const fetchPaymentGatewayProvider = async () => {
      try {
        const response = await fetch(`${apiBaseUrl}/system/paymentGatewayProvider`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          },
        });

        if (response.ok) {
          const data = await response.json();
          setPaymentProvider(data.paymentGatewayProvider);
        } else {
          console.error("Failed to fetch payment provider");
        }
      } catch (error) {
        console.error("Error fetching payment provider:", error);
      }
    };

    fetchPaymentGatewayProvider();
  }, [apiBaseUrl]);



  const loginResponse = useSelector(state => state.loginResponse);


  useEffect(() => {
    if (loading) {
      const timer = setInterval(() => {
        // Update loading text with animated dots
        if (book === false) {
          setLoadingText('Request Processing' + dots);
        }
        else {
          setLoadingText('Payment Processing' + dots);
        }
        setDots((prevDots) => (prevDots.length >= 3 ? '' : prevDots + '.'));
      }, 500);

      return () => {
        clearInterval(timer);
      };
    }
  }, [loading, dots, book]);


  const [acceptRules, setAcceptRules] = useState(false);
  const [acceptBookingConditions, setAcceptBookingConditions] = useState(false);
  const [acceptEmails, setAcceptEmails] = useState(false);
  const [acceptSms, setAcceptSms] = useState(false);
  const promoCode = useSelector(state => state.promoCode?.promoCode ?? '');
  const codeApplied = useSelector(state => state.promoCode?.codeApplied ?? false);

  const [pointsApplied, setPointsApplied] = useState(false); // State to track whether the code has been applied

  const [isOutboundExpanded, setIsOutboundExpanded] = useState(false);
  const [isReturnExpanded, setIsReturnExpanded] = useState(false);

  const toggleOutboundExpand = () => {
    setIsOutboundExpanded(!isOutboundExpanded);
  };
  const toggleReturnExpand = () => {
    setIsReturnExpanded(!isReturnExpanded);
  };


  const [shouldNavigateBack, setShouldNavigateBack] = useState(true);


  const navigate = useNavigate();

  useEffect(() => {
    // Navigate to '/booking' and replace the current entry in the history stack
    navigate('/terms', { replace: true });

    // Cleanup function
    return () => {
      if (shouldNavigateBack) {
        navigate('/terms');
      }
    };
  }, [navigate, shouldNavigateBack]);



  // Bus Details

  const showReturnTransferType =
      createBookingResponse.basket.transfers.length > 1 &&
      createBookingResponse.basket.transfers[0].transferType.code !==
      createBookingResponse.basket.transfers[1].transferType.code;


  const handlePayment = async () => {
    // Set loading to true to show the spinner
    setLoading(true);
    setShouldNavigateBack(false);

    const requestBody = {
      "basket": {
        "id": createBookingResponse.basket.id,
        "acceptRules": acceptRules,
        "acceptTerms": acceptBookingConditions,
        "receiveEmails": acceptEmails,
        "receiveSms": acceptSms
      }
    }

    const headers = {
      'Content-Type': 'application/json'
    };

    try {
      const response = await fetch(`${apiBaseUrl}/basket/updateBasket`, {
        method: 'POST',
        headers,
        body: JSON.stringify(requestBody),
      });


      if (response.ok) {
        const data = await response.json();
        await dispatch(setCreateBookingResponse(data));

        if (book === false) {
          await dispatch(setCreateBookingResponse(data));
          const termsRequestCheckout = {
            currency: quoteResponse.basket.currency[0],
            value: parseFloat((Math.round(createBookingResponse.basket.totalToPay) / 100).toFixed(2)),
            items: [{
              item_name: createBookingResponse.basket.transfers[0].fromDestination.name + " to " + createBookingResponse.basket.transfers[0].toDestination.name, // Name of the item
              price: parseFloat((Math.round(createBookingResponse.basket.totalToPay) / 100).toFixed(2)),
              item_category: createBookingResponse.basket.transfers[0].transferType.description,
              item_category2: createBookingResponse.basket.transfers.length > 1 ? "Return" : "One way", // Category based on number of transfers
              quantity: 1 // Quantity of the item
            }]
          }
          requestTermsCheckout(termsRequestCheckout)


          const paymentResponse = await fetch(`${apiBaseUrl}/basket/proceed/step/payment/basketId/${createBookingResponse.basket.id}`, {
            method: 'GET',
            headers,
          });
          if (paymentResponse.ok) {
            const paymentResponseData = await paymentResponse.json();
            dispatch(setCreateBookingResponse(paymentResponseData));

            navigate('/payment');
          } else {
            // Handle error cases
          }
          navigate('/success/false');
        } else if (book === true) {
          dispatch(setCreateBookingResponse(data));


          const paymentResponse = await fetch(`${apiBaseUrl}/basket/proceed/step/payment/basketId/${createBookingResponse.basket.id}`, {
            method: 'GET',
            headers,
          });

          if (paymentResponse.ok && createBookingResponse.basket.totalToPay === 0) {
            navigate('/success/false');

          } else if (paymentResponse.ok) {
            const paymentResponseData = await paymentResponse.json();
            dispatch(setCreateBookingResponse(paymentResponseData));
            // console.log(paymentResponseData)


            async function createPaymentIntent(paymentResponseData) {
              // Replace with actual base URL
              const url = `${apiBaseUrl}/basket/createPaymentIntent`;

              // Preparing the body data as specified
              const body = JSON.stringify({
                bookingId: paymentResponseData.basket.bookingId,
                currencyCode: paymentResponseData.basket.currency[0],
                returnUrl: `${frontBaseUrl}/success/true`, // Replace with your actual success URL
              });

              try {
                const response = await fetch(url, {
                  method: 'POST',
                  headers,
                  body
                });

                if (!response.ok) {
                  throw new Error(`Error: ${response.statusText}`);
                }

                const responseData = await response.json();
                // console.log('Payment Intent Created:', responseData);
                dispatch(setCreateIntentResponse(responseData))
              } catch (error) {
                console.error('Failed to create payment intent:', error);
                // Handle errors (e.g., show error message to the user)
              }
            }

            if (paymentProvider === "airwallex" && paymentResponseData) {
              console.log('triggering payment intent');
              await createPaymentIntent(paymentResponseData);
            }
            
            
            // Make Request before payment
            const bookingRequestDetails = {
              currency: quoteResponse.basket.currency[0],
              value: parseFloat((Math.round(createBookingResponse.basket.totalToPay) / 100).toFixed(2)),
              items: [{
                item_name: createBookingResponse.basket.transfers[0].fromDestination.name + " to " + createBookingResponse.basket.transfers[0].toDestination.name, // Name of the item
                price: parseFloat((Math.round(createBookingResponse.basket.totalToPay) / 100).toFixed(2)),
                item_category: createBookingResponse.basket.transfers[0].transferType.description,
                item_category2: createBookingResponse.basket.transfers.length > 1 ? "Return" : "One way", // Category based on number of transfers
                quantity: 1 // Quantity of the item
              }]
            }

            // Push the search event to the data layer
            pushBookingMakeRequest(bookingRequestDetails);



            navigate('/payment');
          }
          else {

          }
        }
      } else {
        // Handle error cases
      }
    } catch (error) {
      // Handle any errors that might occur during the fetch or JSON parsing
      // console.error('An error occurred:', error);
    } finally {
      // Regardless of success or failure, set loading to false
      setLoading(false);
    }
  };

  const [submitClicked, setSubmitClicked] = useState(false);

  const handleApplyCode = async (event) => {
    event.preventDefault();
    // Loyalty points and promo codes are mutually exclusive — bail if points are already applied
    if (pointsApplied) {
      return;
    }
    setSubmitClicked(true);
    setLoadingPromoCode(true)
    // Check if promoCode is empty
    if (promoCode.trim() === '') {
      setPromoCodeError('Please Enter Promo Code');
      return; // Exit early if promoCode is empty
    } else {
      setPromoCodeError(''); // Clear the error message if promoCode is not empty
    }
    if (!codeApplied) {

      // Gather Terms Promo Code  for GTM
      const termsPromoCodeDetails = {
        'DLV - promoCode': promoCode
      };

      // Push the Terms Promo Code event to the data layer
      pushTermsPromoCode(termsPromoCodeDetails);

      // Create an object with the promo code and basket ID
      const requestPayload = {
        basket: {
          id: quoteResponse.basket.guid, // Replace with the actual basket ID
          promoCode: promoCode,
        },
      };

      const headers = {
        'Content-Type': 'application/json'
      };
      try {
        const response = await fetch(`${apiBaseUrl}/basket/updateBasket`, {
          method: 'POST',
          headers,
          body: JSON.stringify(requestPayload),
        });

        if (response.ok) {
          const responseData = await response.json();

          if (responseData.status_code === 400) {
            // Display the error message from the API response in the modal
            setPromoCodePopError(responseData.notifications[0].message.content);
            openErrorModal();
            dispatch(setCodeApplied(false));
            setLoadingPromoCode(false)
          }
          else if (responseData.status_code === 200) {
            // Set codeApplied to true to change the button text
            dispatch(setCodeApplied(true));
            // Save the response to Redux
            dispatch(updateBookingPrice(responseData.basket.totalToPay, responseData.basket.toPayPerPerson, transferType, book, short_description));
            dispatch(setLoginResonse(responseData));
            dispatch(setCreateBookingResponse(responseData))
            setLoadingPromoCode(false)
          }
        } else {
          // Handle API errors here
          // console.log('API error:', response.status);
        }
      } catch (error) {
        // console.error('API request failed:', error);
        // Handle any other errors that may occur during the API call
      }
    }
  };

  const handleDoNotApplyPoints = async (event) => {
    event.preventDefault();
    setLoadingLoyality(true)
    // Create an object with the promo code and basket ID
    const requestPayload = {
      basket: {
        id: quoteResponse.basket.guid, // Replace with the actual basket ID
        pointsApplied: false,
      },
    };

    const headers = {
      'Content-Type': 'application/json'
    };
    try {
      const response = await fetch(`${apiBaseUrl}/basket/updateBasket`, {
        method: 'POST',
        headers,
        body: JSON.stringify(requestPayload),
      });

      if (response.ok) {
        const responseData = await response.json();

        dispatch(updateBookingPrice(responseData.basket.totalToPay, responseData.basket.toPayPerPerson, transferType, book, short_description));
        dispatch(setLoginResonse(responseData));
        dispatch(setCreateBookingResponse(responseData))
        // Set codeApplied to true to change the button text
        setPointsApplied(false);
        // Save the response to Redux
        setLoadingLoyality(false)
      } else {
        // Handle API errors here
        // console.log('API error:', response.status);
      }
    } catch (error) {
      // console.error('API request failed:', error);
      // Handle any other errors that may occur during the API call
    }
  };

  const handleApplyLoyalityPoints = async (event) => {
    event.preventDefault();
    // Loyalty points and promo codes are mutually exclusive — bail if a promo code is already applied
    if (codeApplied) {
      return;
    }
    setLoadingLoyality(true);
    // Gather Terms Loyality Points  for GTM
    const termsLoyalityPointDetails = {
      'DLV- loyalityPoints': "Points Applied"
    };

    // Push the Terms Loyality Points  event to the data layer
    pushTermsLoyalityPoint(termsLoyalityPointDetails);

    // Create an object with the promo code and basket ID
    const requestPayload = {
      basket: {
        id: quoteResponse.basket.guid, // Replace with the actual basket ID
        pointsApplied: true,
      },
    };

    const headers = {
      'Content-Type': 'application/json'
    };
    try {
      const response = await fetch(`${apiBaseUrl}/basket/updateBasket`, {
        method: 'POST',
        headers,
        body: JSON.stringify(requestPayload),
      });

      if (response.ok) {
        const responseData = await response.json();

        dispatch(updateBookingPrice(responseData.basket.totalToPay, responseData.basket.toPayPerPerson, transferType, book, short_description));
        dispatch(setLoginResonse(responseData));
        // Set codeApplied to true to change the button text
        setPointsApplied(true);
        dispatch(setCreateBookingResponse(responseData))
        // Save the response to Redux
        setLoadingLoyality(false);
      } else {
        // Handle API errors here
        // console.log('API error:', response.status);
      }
    } catch (error) {
      // console.error('API request failed:', error);
      // Handle any other errors that may occur during the API call
    }
  };

  // EXPAND MORE
  const descriptionFullArray = createBookingResponse.basket.transfers[0].transferType.descriptionLong;


  // // Create a temporary div element to parse the HTML
  // const tempDiv = document.createElement('div');
  // tempDiv.innerHTML = html;

  // // Extract the text content of each <li> element
  // const liElements = tempDiv.querySelectorAll('li');
  // const descriptionFullArray = Array.from(liElements).map((li) => li.textContent);

  const transportTypeMapping = {
    AIR: {
      AIR: "Flight Number",
      BUS: "Bus Number",
      FERR: "Cruise Number",
      GOLF: "Flight Number",
      RES: "Flight Number",
      TRBU: "Train Number",
    },
    BUS: {
      AIR: "Bus Number",
      BUS: "Bus Number",
      FERR: "Bus Number",
      GOLF: "Bus Number",
      RES: "Bus Number",
      TRBU: "Bus Number",
    },
    FERR: {
      AIR: "Cruise Number",
      BUS: "Cruise Number",
      FERR: "Cruise Number",
      GOLF: "Cruise Number",
      RES: "Cruise Number",
      TRBU: "Cruise Number",
    },
    GOLF: {
      AIR: "Flight Number",
      BUS: "Bus Number",
      FERR: "Cruise Number",
      GOLF: "Tee Time",
      RES: "Pick Up Time",
      TRBU: "Train Number",
    },
    RES: {
      AIR: "Flight Number",
      BUS: "Bus Number",
      FERR: "Cruise Number",
      GOLF: "Tee Time",
      RES: "Pick Up Time",
      TRBU: "Train Number",
    },
    TRBU: {
      AIR: "Train Number",
      BUS: "Train Number",
      FERR: "Train Number",
      GOLF: "Train Number",
      RES: "Train Number",
      TRBU: "Train Number",
    },
  };


  // Function to get transport type based on destination types
  const getTransportType = (fromType, toType) => {
    if (transportTypeMapping[fromType] && transportTypeMapping[fromType][toType]) {
      return transportTypeMapping[fromType][toType];
    }
    return "Transport Number"; // Fallback if no mapping is found
  };

  //  Get transport types based on travel details
  const fromType = travelDetails.pickupValue.type; // e.g., 'AIR'
  const toType = travelDetails.dropoffValue.type;  // e.g., 'RES'

  const transportTypeOutbound = getTransportType(fromType, toType);
  const transportTypeReturn = getTransportType(toType, fromType);
  // Function to get transport time label based on the origin and destination types

  return (
    <div>
      <Card sx={{ backgroundColor: '#f1f2f5', marginTop: '-12px', }}>
        <CardContent sx={{ backgroundColor: '#f1f2f5' }}>
          <Grid container spacing={2} sx={{
            flexGrow: 1,
            backgroundColor: '#f1f2f5'
          }}>
            <Grid item xs={12} md={12} sx={{ display: 'flex', justifyContent: 'center' }}>
              <Typography variant="h5" sx={{
                textAlign: 'left',
                color: '#444',
                font: '18px arial,serif',
                fontFamily: 'Nexa,sans-serif',
                fontWeight: 'bold', marginTop: '-10px',
              }}>
                Your Transfers
              </Typography>
            </Grid>
            <Grid item xs={12} md={12}>
              <Typography variant="subtitle1" style={{
                textAlign: 'left',
                font: '12px arial,serif',
                fontFamily: 'Nexa,sans-serif',
                color: '#444',
              }}>
                <span style={{ fontWeight: 'bold' }}>Outbound:</span> {createBookingResponse.basket.transfers[0].fromDestination.destinationTypeCode === 'RES' ? `${createBookingResponse.basket.transfers[0].fromAccommodation.name} - `:''} {travelDetails.pickupValue.label} To {travelDetails.dropoffValue.label} - {createBookingResponse.basket.transfers[0].toDestination.destinationTypeCode === 'RES' ? `${createBookingResponse.basket.transfers[0].toAccommodation.name}`:''} On The {dayjs(travelDetails.outboundDate).format('D MMM, YYYY')} At
                <span> {travelDetails.outboundTime}{createBookingResponse.basket.transfers[0].flightNumber && `, ${transportTypeOutbound} ${createBookingResponse.basket.transfers[0].flightNumber}`}, For  </span>{travelDetails.adultsCount > 0 || travelDetails.childrenCount > 0 || travelDetails.infantsCount > 0 ? (
                  <span>
                    {travelDetails.adultsCount} Adults
                    {travelDetails.childrenCount.length > 0 &&
                        `, ${travelDetails.childrenCount.length} ${travelDetails.childrenCount.length > 1 ? 'Children' : 'Child'}`}
                    {createBookingResponse.basket.transfers[0].numberOfHoldItems > 0 &&
                        `, Hold Luggage ${createBookingResponse.basket.transfers[0].numberOfHoldItems}`}
                    {createBookingResponse.basket.transfers[0].numberOfSkis > 0 &&
                        `, Skis ${createBookingResponse.basket.transfers[0].numberOfSkis}`}
                    {createBookingResponse.basket.transfers[0].numberOfBikes > 0 &&
                        `, Bikes/Golf Bags ${createBookingResponse.basket.transfers[0].numberOfBikes}`}
                  </span>
              ) : null}
              </Typography>
            </Grid>
            <hr/>
            {createBookingResponse.basket.transfers[1] && (
                <Grid item xs={12} md={12}>
                  <Typography variant="subtitle1" style={{
                    textAlign: 'left',
                    font: '12px arial,serif',
                    fontFamily: 'Nexa,sans-serif',
                    color: '#444',
                    marginTop: '-22px'
                  }}>
                    <span style={{ fontWeight: 'bold' }}>Inbound:</span> {createBookingResponse.basket.transfers[1].fromDestination.destinationTypeCode === 'RES' ? `${createBookingResponse.basket.transfers[1].fromAccommodation.name} - `:''}{travelDetails.dropoffValue.label} To {travelDetails.pickupValue.label} {createBookingResponse.basket.transfers[1].toDestination.destinationTypeCode === 'RES' ? ` - ${createBookingResponse.basket.transfers[1].toAccommodation.name} - `:''} On  The {dayjs(travelDetails.returnDate).format('D MMM, YYYY')} At
                    <span> {travelDetails.returnTime}{createBookingResponse.basket.transfers[1].flightNumber && `, ${transportTypeReturn} ${createBookingResponse.basket.transfers[1].flightNumber}`}, For </span>{travelDetails.adultsCount > 0 || travelDetails.childrenCount > 0 || travelDetails.infantsCount > 0 ? (
                      <span>
                      {travelDetails.adultsCount} Adults
                        {travelDetails.childrenCount.length > 0 &&
                            `, ${travelDetails.childrenCount.length} ${travelDetails.childrenCount.length > 1 ? 'Children' : 'Child'} `}
                        {createBookingResponse.basket.transfers[1].numberOfHoldItems > 0 &&
                            `, Hold Luggage ${createBookingResponse.basket.transfers[1].numberOfHoldItems}`}
                        {createBookingResponse.basket.transfers[1].numberOfSkis > 0 &&
                            `, Skis ${createBookingResponse.basket.transfers[1].numberOfSkis}`}
                        {createBookingResponse.basket.transfers[1].numberOfBikes > 0 &&
                            `, Bikes/Golf Bags ${createBookingResponse.basket.transfers[1].numberOfBikes}`}
                    </span>
                  ) : null}
                  </Typography>
                </Grid>
            )}
            <Grid item xs={12} md={12}>
              <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    textAlign: 'left',
                    color: '#444',
                    font: '16px arial,serif',
                    fontFamily: 'Nexa,sans-serif',
                    fontWeight: 'bold', marginTop: '-12px',
                  }}
              >
                <Typography variant="h5" sx={{
                  textAlign: 'left',
                  color: '#444',
                  font: '14px arial,serif',
                  fontFamily: 'Nexa,sans-serif',
                  fontWeight: 'bold',
                  marginTop: '6px',
                  marginRight: '16px'
                }}>
                  {createBookingResponse.basket.transfers.length > 1 && createBookingResponse.basket.transfers[0].transferType.description !== createBookingResponse.basket.transfers[1].transferType.description ? (
                      <>
                        <div>
                          Outbound Transfer Type: {createBookingResponse.basket.transfers[0].transferType.description}
                          &nbsp; &nbsp;
                          Inbound Transfer Type: {createBookingResponse.basket.transfers[1].transferType.description}
                        </div>
                      </>
                  ) : (
                      <div>Transfer Type: {createBookingResponse.basket.transfers[0].transferType.description}</div>
                  )}
                </Typography>

                <Typography variant="h5" sx={{
                  textAlign: 'left',
                  color: '#444',
                  font: '14px arial,serif',
                  fontFamily: 'Nexa,sans-serif',
                  fontWeight: 'bold', marginTop: '6px',
                }}>
                  Total Price: {currencySymbols[createBookingResponse.basket.currency[0]]} {(Math.round(totalCost) / 100).toFixed(2)}
                </Typography>
              </Box>

            </Grid>


          </Grid>
        </CardContent>
      </Card>
      <Grid container spacing={2} sx={{
        flexGrow: 1,
        backgroundColor: '#FCFDFD',
      }}>
         {/* Progress Bar Section */}
         <Grid
          item
          xs={12}
          md={9}
          sx={{
            marginLeft: { xs: '-80px', sm: '-50px', md: '0px', lg: '170px' }, // Responsive margin for progress bar
          }}
          style={{
            display: 'flex',
            justifyContent: 'center', // Right align for larger screens, center for smaller
            alignItems: 'center',
            padding: '0 10px 10px 0',
          }}
        >
          <ProgressBar currentStep={3} />
        </Grid>
        <Grid
          item
          xs={12}
          md={8}
          lg={8}
          sx={{
            marginLeft: { xs: '8px', sm: '16px', md: '108px', lg: '180px' }, // Responsive margin for heading
          }}
          style={{
            display: 'flex',
            justifyContent: 'center', // Center heading for small screens
            alignItems: 'center',
            textAlign: 'center',
          }}>
          <Typography variant="h2" sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            fontSize: '1.5rem',
            fontWeight: '700',
            color: '#333',
            fontFamily: 'Nexa,sans-serif',
            lineHeight: '1.1',
          }}>
            Your <span className={classes.underline}>Travel<span className={classes.underlineBefore}></span></span> Details
          </Typography>

        </Grid>

        {/* OUTBOUND TRANSFER TYPE */}
        <Grid item xs={12} md={showReturnTransferType ? 6 : 12} sx={{ marginTop: '15px' }}>
          <Card style={{ backgroundColor: '#F4FAFA', color: '#265886' }}>
            <CardContent>
              <Typography variant="h5" component="h2" sx={{ textAlign: 'center', fontSize: '24px' }}>
                Transfer type: <strong>{getTransferType(createBookingResponse.basket.transfers[0].transferType.code)}</strong>
              </Typography>
              <List style={{ fontSize: '14px', fontFamily: 'Nexa,sans-serif' }}>
                {!isOutboundExpanded && (
                  <>
                    <ListItem>
                      <ListItemIcon>
                        <CheckCircleIcon style={{ strokeWidth: '1' }} />
                      </ListItemIcon>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: createBookingResponse.basket.transfers[0].transferType.descriptionShort[0],
                        }}
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <CheckCircleIcon />
                      </ListItemIcon>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: createBookingResponse.basket.transfers[0].transferType.descriptionShort[1],
                        }}
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <CheckCircleIcon />
                      </ListItemIcon>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: createBookingResponse.basket.transfers[0].transferType.descriptionShort[2],
                        }}
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <CheckCircleIcon />
                      </ListItemIcon>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: createBookingResponse.basket.transfers[0].transferType.descriptionShort[3],
                        }}
                      />
                    </ListItem>
                  </>
                )}
                {isOutboundExpanded && (
                  <div>
                    {descriptionFullArray.map((item, index) => (
                      <ListItem key={index}>
                        <ListItemIcon>
                          <CheckCircleIcon />
                        </ListItemIcon>
                        <div dangerouslySetInnerHTML={{ __html: item }} />
                      </ListItem>
                    ))}
                  </div>
                )}
              </List>

              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    mt: 3, mb: 2, backgroundColor: 'rgb(17, 137, 17)',
                    color: 'rgb(255, 255, 255)',
                    borderRadius: '6px',
                    marginTop: '14px',
                    padding: '0px 50px',
                    fontFamily: '"Nexa","Arial",sans-serif!important',
                    fontWeight: '400',
                    fontSize: '16px',
                    lineHeight: '1.75',
                    letterSpacing: '0.02857em',
                    minWidth: '183px',
                    minHeight: '50px',
                    display: 'flex',
                    '&.loading': {
                      color: theme.palette.primary.main, // Change this to the color you want
                    },
                  }}
                  style={{ display: 'flex', justifyContent: 'center' }}
                  onClick={toggleOutboundExpand}
                >
                  {isOutboundExpanded ? 'COLLAPSE MORE INFO' : 'EXPAND FOR MORE INFO'}
                </Button>
              </div>
            </CardContent>
          </Card>
        </Grid>

        {/* RETURN TRANSFER TYPE */}
        {
          createBookingResponse.basket.transfers.length > 1
            && createBookingResponse.basket.transfers[0].transferTypeCode !== createBookingResponse.basket.transfers[1].transferTypeCode
            && (
            <Grid item xs={12} md={6} sx={{ marginTop: '15px' }}>
              <Card style={{ backgroundColor: '#F4FAFA', color: '#265886' }}>
                <CardContent>
                  <Typography variant="h5" component="h2" sx={{ textAlign: 'center', fontSize: '24px' }}>
                    Transfer type: <strong>{getTransferType(createBookingResponse.basket.transfers[1].transferType.code)}</strong>
                  </Typography>
                  <List style={{ fontSize: '14px', fontFamily: 'Nexa,sans-serif' }}>
                    {!isReturnExpanded && (
                      <>
                        <ListItem>
                          <ListItemIcon>
                            <CheckCircleIcon style={{ strokeWidth: '1' }} />
                          </ListItemIcon>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: createBookingResponse.basket.transfers[1].transferType.descriptionShort[0],
                            }}
                          />
                        </ListItem>
                        <ListItem>
                          <ListItemIcon>
                            <CheckCircleIcon />
                          </ListItemIcon>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: createBookingResponse.basket.transfers[1].transferType.descriptionShort[1],
                            }}
                          />
                        </ListItem>
                        <ListItem>
                          <ListItemIcon>
                            <CheckCircleIcon />
                          </ListItemIcon>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: createBookingResponse.basket.transfers[1].transferType.descriptionShort[2],
                            }}
                          />
                        </ListItem>
                        <ListItem>
                          <ListItemIcon>
                            <CheckCircleIcon />
                          </ListItemIcon>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: createBookingResponse.basket.transfers[1].transferType.descriptionShort[3],
                            }}
                          />
                        </ListItem>
                      </>
                    )}
                    {isReturnExpanded && (
                      <div>
                        {descriptionFullArray.map((item, index) => (
                          <ListItem key={index}>
                            <ListItemIcon>
                              <CheckCircleIcon />
                            </ListItemIcon>
                            <div dangerouslySetInnerHTML={{ __html: item }} />
                          </ListItem>
                        ))}
                      </div>
                    )}
                  </List>

                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                      type="submit"
                      variant="contained"
                      sx={{
                        mt: 3, mb: 2, backgroundColor: 'rgb(17, 137, 17)',
                        color: 'rgb(255, 255, 255)',
                        borderRadius: '6px',
                        marginTop: '14px',
                        padding: '0px 50px',
                        fontFamily: '"Nexa","Arial",sans-serif!important',
                        fontWeight: '400',
                        fontSize: '16px',
                        lineHeight: '1.75',
                        letterSpacing: '0.02857em',
                        minWidth: '183px',
                        minHeight: '50px',
                        display: 'flex',
                        '&.loading': {
                          color: theme.palette.primary.main, // Change this to the color you want
                        },
                      }}
                      style={{ display: 'flex', justifyContent: 'center' }}
                      onClick={toggleReturnExpand}
                    >
                      {isReturnExpanded ? 'COLLAPSE MORE INFO' : 'EXPAND FOR MORE INFO'}
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </Grid>
          )}

        {/* Confirmation Card */}
        <Grid item xs={12} md={12}>
          <Card sx={{
            fontSize: '16px',
            fontFamily: "Nexa,sans-serif",
            color: '#265886'
          }}>
            <CardContent>
              <Typography variant="body1" sx={{ textAlign: 'left' }}>
                <InfoIcon sx={{
                  color: '#265886',
                  fontSize: '22px',
                  marginBottom: '-5px'
                }} /> Confirmation of pick up time is sent to you by email and SMS by 17:00 (CET) the day prior to each journey.
              </Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', marginTop: '20px' }}>
                Please ensure you have read and understand our Terms & Conditions, which contain more detailed information, including about Luggage Allowance, Child Seats, waiting times in case of flights landing earlier or later than scheduled and the general Conditions of Carriage. If you have any questions, please don’t hesitate to ask us.
              </Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', marginTop: '20px' }}>
                Please make sure you check your junk folder for emails and add us to your safe senders list.
              </Typography>


              {/* Checkboxes */}
              <Grid item xs={12} md={12} sx={{ marginTop: '10px', marginLeft: '70px', color: 'grey' }}>
                <Grid container alignItems="center" spacing={2}>
                  <Grid item>
                    <FormControlLabel
                      control={<Checkbox checked={acceptRules} onChange={() => setAcceptRules(!acceptRules)} />}
                    />
                  </Grid>
                  <Grid item>
                    <Typography variant="body1">
                      I accept the rules of the transfer types and confirm that my booking details are correct
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={12} sx={{ marginTop: '10px', marginLeft: '70px', color: 'grey' }}>
                <Grid container alignItems="center" spacing={2}>
                  <Grid item>
                    <FormControlLabel
                      control={<Checkbox checked={acceptBookingConditions} onChange={() => setAcceptBookingConditions(!acceptBookingConditions)} />}
                    />
                  </Grid>
                  <Grid item>
                    <Typography variant="body1">
                      I accept the Ski-Lifts <a href="https://www.lifts.to/terms-and-conditions/" target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>Booking Conditions</a>,
                      <a href="https://www.lifts.to/terms-of-use/" target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>Website Terms of Use</a> and
                      <a href="https://www.lifts.to/privacy-policy/" target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>Privacy Policy</a>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={12} sx={{ marginTop: '10px', marginLeft: '70px', color: 'grey' }}>
                <Grid container alignItems="center" spacing={2}>
                  <Grid item>
                    <FormControlLabel
                      control={<Checkbox checked={acceptEmails} onChange={() => setAcceptEmails(!acceptEmails)} />}
                    />
                  </Grid>
                  <Grid item>
                    <Typography variant="body1">
                      I'm happy for Ski-Lifts or Sea-Lifts to send the occasional email to the Lead Passenger email address
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              {smsCheck && (
                  <Grid
                      item
                      xs={12}
                      md={12}
                      sx={{ mt: '10px', color: 'grey' }}
                  >
                    <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          columnGap: 1,
                          flexWrap: 'nowrap',
                          ml: '59px'
                        }}
                    >
                      <Checkbox
                          checked={acceptSms}
                          onChange={() => setAcceptSms(!acceptSms)}
                          sx={{ flexShrink: 0, mt: '-4px' }}
                      />

                      <Typography
                          variant="body1"
                          sx={{
                            flex: 1,
                            minWidth: 0,
                            maxWidth: 1000,
                            ml: '25px'
                          }}
                      >
                        I understand that receiving SMS is required for this booking and agree to
                        receive pickup time and service notifications from Ski-Lifts. Message
                        frequency varies. Msg &amp; data rates may apply. Reply STOP to opt out
                        (opting out may prevent service delivery). HELP for help.
                      </Typography>
                    </Box>
                  </Grid>
              )}

            </CardContent>
          </Card>

          <NotificationComponent response={createBookingResponse} transferType={transferType} />
          <Grid item xs={12} md={12} style={{ textAlign: 'left', marginTop: '20px' }}>
            <Typography variant="h2" sx={{
              fontFamily: '"Nexa","Arial",sans-serif!important',
              fontSize: '30px',
              color: '#265886',
            }}>
              <strong>Your Total: {currencySymbols[createBookingResponse.basket.currency[0]]} {(Math.round(createBookingResponse.basket.totalToPay) / 100).toFixed(2)}</strong>
            </Typography>
            <Typography variant="h5" sx={{
              fontFamily: '"Nexa","Arial",sans-serif!important',
              fontSize: '17px',
              color: '#265886',
              marginLeft: '150px',
              marginTop: '10px'
            }}>
              {currencySymbols[createBookingResponse.basket.currency[0]]} {(costPerPerson
                ? (Math.round(createBookingResponse.basket.toPayPerPerson) / 100).toFixed(2)
                : (Math.round(createBookingResponse.basket.toPayPerPerson) / 100).toFixed(2)
              )} Per Person

            </Typography>
          </Grid>

          <Grid item xs={12} md={12} style={{ marginTop: '20px' }}>
            <Card style={{ backgroundColor: '#E7F3FD' }}>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <Button
                        type="submit"
                        variant="contained"
                        sx={{
                          mt: 3, mb: 2, backgroundColor: 'rgb(17, 137, 17)',
                          color: 'rgb(255, 255, 255)',
                          borderRadius: '6px',
                          marginTop: '14px',
                          padding: '0px 50px',
                          fontFamily: '"Nexa","Arial",sans-serif!important',
                          fontWeight: '400',
                          fontSize: '16px',
                          lineHeight: '1.75',
                          letterSpacing: '0.02857em',
                          minWidth: '183px',
                          minHeight: '50px',
                          display: 'flex',
                          '&.loading': {
                            color: theme.palette.primary.main, // Change this to the color you want
                          },

                        }}
                        className={`${loading ? 'loading' : ''}`}
                        fullWidth
                        disabled={loading || !acceptRules || !acceptBookingConditions || (!acceptSms && smsCheck)}
                        onClick={handlePayment}
                      >
                        {loading ? (
                          <>
                            <CircularProgress size={24} style={{ color: 'grey' }} />
                            &nbsp;&nbsp;{loadingText}
                          </>
                        ) : book === false ? (
                          "Make Request"
                        ) : (
                          "Proceed to Payment"
                        )}
                      </Button>
                    </div>

                    {/* Inside your component JSX, add the following code to render the modal: */}

                    <Dialog open={isErrorModalOpen} onClose={closeErrorModal}>
                      <DialogTitle>Error</DialogTitle>
                      <DialogContent>
                        <DialogContentText>{promoCodePopError}</DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={closeErrorModal} color="primary" autoFocus>
                          OK
                        </Button>
                      </DialogActions>
                    </Dialog>

                    {/* Apply Code */}
                    <form onSubmit={handleApplyCode}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <TextField
                            sx={{ backgroundColor: 'white', }}
                            label="Enter Code"
                            fullWidth
                            value={promoCode}
                            onChange={(e) => {
                              dispatch(setPromoCode(e.target.value));
                              setPromoCodeError(''); // Clear the error message when the user types in the promo code field
                              if (promoCodeError) {
                                setSubmitClicked(false); // Reset submitClicked when the user starts correcting the input
                              }
                            }}
                            disabled={codeApplied || pointsApplied}
                          />
                          {promoCodeError && <p style={{ color: 'red' }}>{promoCodeError}</p>}
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <Button
                            type="submit"
                            variant="contained"
                            sx={{ marginTop: '10px' }}
                            startIcon={codeApplied ? <CheckCircleIcon /> : null}
                            disabled={pointsApplied || codeApplied}
                            style={{ cursor: pointsApplied || codeApplied ? 'not-allowed' : 'pointer' }}
                            fullWidth
                          >
                            {
                              codeApplied ?
                                'Code Applied' :
                                (loadingPromoCode && !promoCodeError && submitClicked ?
                                  <>
                                    <CircularProgress size={24} style={{ color: 'white' }} />
                                    <span>Applying Promo Code...</span>
                                  </> :
                                  'Apply Code')
                            }
                          </Button>
                        </Grid>
                      </Grid>
                    </form>
                  </Grid>

                  {/* Loyality Points */}
                  <Grid item xs={12} md={6} style={{ marginTop: '15px' }}>
                    <Card>
                      <CardContent style={{ marginTop: '20px', textAlign: 'center', color: '#265886' }}>
                        <Typography variant="h5" component="div">
                          Existing customer loyalty points
                        </Typography>
                        {loginResponse && loginResponse.basket.customer && loginResponse.basket.customer.pointsValue > 0 ? (
                          <Typography color="text.secondary" style={{ marginTop: '13px' }}>
                            {loginResponse.basket.customer.pointsValue > 0
                              ? `You have ${currencySymbols[createBookingResponse.basket.currency[0]]} ${(Math.round(loginResponse.basket.customer.pointsValue) / 100).toFixed(2)} loyalty points with Ski-Lifts`
                              : "You do not have existing loyalty points with Ski-Lifts"}
                          </Typography>


                        ) : (
                          <Typography color="text.secondary" style={{ marginTop: '13px' }}>
                            You do not have existing loyalty points with Ski-Lifts
                          </Typography>
                        )}
                        {loginResponse && loginResponse.basket.customer.points > 0 && (
                          <div>
                            {!pointsApplied && (
                              <Button
                                variant="contained"
                                sx={{
                                  mt: 3, mb: 2, backgroundColor: '#265886',
                                  color: 'rgb(255, 255, 255)',
                                  borderRadius: '6px',
                                  marginTop: '14px',
                                  padding: '0px 50px',
                                  fontFamily: '"Nexa","Arial",sans-serif!important',
                                  fontWeight: '400',
                                  fontSize: '16px',
                                  lineHeight: '1.75',
                                  letterSpacing: '0.02857em',
                                  minWidth: '183px',
                                  minHeight: '50px',
                                  display: 'flex',
                                }}
                                onClick={handleApplyLoyalityPoints}
                                disabled={codeApplied}
                                style={{ cursor: codeApplied ? 'not-allowed' : 'pointer' }}
                                fullWidth
                              >
                                {
                                  loadingLoyality ?
                                    <>
                                      <CircularProgress size={24} style={{ color: 'white', marginRight: '10px' }} />
                                      <span>Applying Points...</span>
                                    </> :
                                    'Apply Points'
                                }
                              </Button>
                            )}

                            {pointsApplied && (
                              <Button
                                variant="contained"
                                sx={{
                                  mt: 3, mb: 2, backgroundColor: '#265886',
                                  color: 'rgb(255, 255, 255)',
                                  borderRadius: '6px',
                                  marginTop: '14px',
                                  padding: '0px 50px',
                                  fontFamily: '"Nexa","Arial",sans-serif!important',
                                  fontWeight: '400',
                                  fontSize: '16px',
                                  lineHeight: '1.75',
                                  letterSpacing: '0.02857em',
                                  minWidth: '183px',
                                  minHeight: '50px',
                                  display: 'flex',
                                }}

                                onClick={handleDoNotApplyPoints}
                                fullWidth
                              >
                                {
                                  loadingLoyality ?
                                    <>
                                      <CircularProgress size={24} style={{ color: 'white', marginRight: '10px' }} />
                                      <span>Revoking Points Applied...</span>
                                    </> :
                                    'Do Not Apply Points'
                                }

                              </Button>
                            )}
                          </div>
                        )}
                      </CardContent>
                    </Card>
                  </Grid>

                </Grid>
              </CardContent>
            </Card>
          </Grid>


        </Grid>
      </Grid>







    </div>
  );
};

export default withStyles(styles, { withTheme: true })(TermsConditionsForm);
